import { Link } from "react-router-dom";
import { Home, LifeBuoy } from "lucide-react";
import SEO from "@/components/SEO";
import AuroraBackground from "@/components/AuroraBackground";
import Reveal from "@/components/Reveal";

export default function NotFound() {
  return (
    <>
      <SEO title="Page not found | Nova" description="The page you were looking for could not be found." path="/404" />
      <section className="relative flex min-h-[80vh] items-center overflow-hidden pt-28">
        <AuroraBackground variant="soft" />
        <div className="container-nova relative">
          <Reveal>
            <p className="label-eyebrow mb-4">Error 404</p>
            <h1 className="font-heading text-5xl font-800 tracking-tighter text-white sm:text-7xl" style={{ fontWeight: 900 }} data-testid="notfound-title">
              Page not found
            </h1>
            <p className="mt-5 max-w-lg text-base leading-relaxed text-white/60">
              The page you were looking for doesn't exist or may have moved. Let's get you back on track.
            </p>
            <div className="mt-8 flex flex-wrap gap-4">
              <Link to="/" className="btn-primary" data-testid="notfound-home">
                <Home size={16} /> Back to homepage
              </Link>
              <Link to="/support" className="btn-ghost" data-testid="notfound-support">
                <LifeBuoy size={16} /> Visit Support
              </Link>
            </div>
          </Reveal>
        </div>
      </section>
    </>
  );
}
